export default __webpack_public_path__ + "static/media/register2.1923fa83.jpg";